import React from 'react';
import BlockRulesPage from './BlockRulesPage';
interface NationalityBlockProps {
  onLogout: () => void;
}
const NationalityBlock: React.FC<NationalityBlockProps> = ({
  onLogout
}) => <BlockRulesPage kind="nationality" onLogout={onLogout} data-id="element-3904" data-mp="i4mfrowwby1d" />;
export default NationalityBlock;